import { render, staticRenderFns } from "./BatchAddMemberView.vue?vue&type=template&id=791cb78f&scoped=true"
import script from "./BatchAddMemberView.vue?vue&type=script&lang=js"
export * from "./BatchAddMemberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791cb78f",
  null
  
)

export default component.exports